/**
 * Lista mínima de contratos para um SELETOR (`TP-052`, T9) — só `id` e um
 * rótulo para exibir, nunca a forma rica de `features/contratos/api/tipos.ts`.
 *
 * Existe aqui, em `shared/`, porque a tela de Faturamento (feature própria,
 * fora de `features/contratos`) precisa escolher um contrato para importar
 * um lote e para filtrar a lista — e o boundary do eslint proíbe uma feature
 * de importar outra (`uma feature nunca importa outra feature`). Reaproveitar
 * `features/contratos/api/contratos.ts` dali violaria essa parede; duplicar
 * a tela inteira de contratos seria pior. Este módulo é o ÚNICO ponto que
 * repete a leitura de `GET /contratos` fora de `features/contratos` — se um
 * terceiro consumidor aparecer, é sinal de promover o resto para cá também.
 */

import { queryOptions } from '@tanstack/react-query';

import { requisitar } from './clienteHttp';

interface ContratoParaEscolhaApi {
  readonly id: string;
  readonly name: string | null;
  readonly uf: string | null;
}

export interface ContratoParaEscolha {
  readonly id: string;
  readonly rotulo: string;
}

function rotular(bruto: ContratoParaEscolhaApi): string {
  const nome = bruto.name ?? `Contrato ${bruto.id.slice(0, 8)}`;
  return bruto.uf !== null ? `${nome} — ${bruto.uf}` : nome;
}

export function opcoesDosContratosParaEscolha() {
  return queryOptions({
    queryKey: ['contratos-para-escolha'] as const,
    queryFn: ({ signal }): Promise<ContratoParaEscolha[]> =>
      requisitar<ContratoParaEscolhaApi[]>('/contratos', { sinal: signal }).then((itens) =>
        itens.map((bruto) => ({ id: bruto.id, rotulo: rotular(bruto) })),
      ),
  });
}
